var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantMenu24DpE8Eaed2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_2314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1248 16.6749L13.6623 13.1374L4.8873 4.37495C2.9373 6.32495 2.9373 9.48745 4.8873 11.4499L10.1248 16.6749ZM18.5998 14.4124C20.5123 15.2999 23.1998 14.6749 25.1873 12.6874C27.5748 10.2999 28.0373 6.87495 26.1998 5.03745C24.3748 3.21245 20.9498 3.66245 18.5498 6.04995C16.5623 8.03745 15.9373 10.7249 16.8248 12.6374L4.6248 24.8374L6.3873 26.5999L14.9998 18.0124L23.5998 26.6124L25.3623 24.8499L16.7623 16.2499L18.5998 14.4124Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_2314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMenu24DpE8Eaed2);
export default __webpack_public_path__ + "static/media/restaurant_menu_24dp_E8EAED 2.fd1359e96b9cc7708de93f0c0913aa4b.svg";
export { ForwardRef as ReactComponent };